const State = {
  partners: []
};
export default State;
